import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class NotFoundRoute extends Route {
  @service router;
  @service notify;
  @service intl;

  beforeModel(transition) {
    this.notify.alert(this.intl.t('not-found.message'), transition);
    this.router.transitionTo('index');
  }
}
